export const labelState = (overviewTabSelectedGraph) => {
  let color = '#1AAA60';
  let backgroundColor = '#E8F8F0';

  if (overviewTabSelectedGraph === 'callback') {
    color = '#E6B300';
    backgroundColor = '#FFF9EC';
  }
  if (overviewTabSelectedGraph === 'assigned') {
    color = '#5A4ED1';
    backgroundColor = '#F0EEFD';
  }
  if (overviewTabSelectedGraph === 'withdrawn') {
    color = '#E4551D';
    backgroundColor = '#FFEFE9';
  }

  return { color, backgroundColor }
}